import {NgModule} from '@angular/core';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MapsModule} from 'src/app/components/maps/maps.module';
import {SharedCareproviderModule} from '../../app-common/shared-careprovider.module';
import {SharedModule} from '../../app-common/shared.module';
import {careserviceRoutingComponents, CareServiceRoutingModule} from './care-service-routing.module';
import {SharedCmsModule} from '../../app-common/shared-cms.module';
import {BookingBtnComponent} from '../../components/booking-btn/booking-btn.component';
import {MatDialogActions, MatDialogContent, MatDialogTitle} from '@angular/material/dialog';
import {CareServiceUrlResolverService} from './services/care-service-url-resolver.service';
import {BookTimeNowModule} from '../../components/book-time-now/book-time-now.module';
import {MatTabsModule} from '@angular/material/tabs';
import {CareServiceInfoTopComponent} from './components/care-service-info-top/care-service-info-top.component';
import {CareServiceShortDescriptionComponent} from './components/care-service-short-description/care-service-short-description.component';
import {CareServiceBookComponent} from './components/care-service-book/care-service-book.component';
import {CareServiceDetailsComponent} from './components/care-service-details/care-service-details.component';
import {CareServiceAboutCpruComponent} from './components/care-service-about-cpru/care-service-about-cpru.component';
import {CareServiceSchemaService} from './services/care-service-schema.service';
import {CpruTabsService} from '../../services/cpru-tabs.service';
import {UiIconComponent} from '../../components/ui/ui-icon/ui-icon.component';
import {UiButtonComponent} from '../../components/ui/ui-button/ui-button.component';

@NgModule({
  declarations: [
    careserviceRoutingComponents,
    CareServiceInfoTopComponent,
    CareServiceShortDescriptionComponent,
    CareServiceBookComponent,
    CareServiceDetailsComponent,
    CareServiceAboutCpruComponent,
  ],
  imports: [
    SharedModule,
    MapsModule,
    SharedCareproviderModule,
    SharedCmsModule,
    CareServiceRoutingModule,
    MatTooltipModule,
    MatExpansionModule,
    BookingBtnComponent,
    MatDialogActions,
    MatDialogContent,
    MatDialogTitle,
    BookTimeNowModule,
    MatTabsModule,
    UiIconComponent,
    UiButtonComponent,
  ],
  providers: [CareServiceUrlResolverService, CareServiceSchemaService, CpruTabsService],
  exports: [],
})
export class CareServiceModule {}
